export default "__VITE_ASSET__c0482bbf__"